import config from '../package.json';
import { webinarListInitState } from './initialStates';
import {
  ENABLE_WEBINAR_RED_DOT,
  FETCH_WEBINAR_LIST_REQUEST,
  FETCH_WEBINAR_LIST_SUCCESS,
  FETCH_WEBINAR_LIST_FAILURE,
  DISABLE_WEBINAR_RED_DOT,
} from '../actions/webinarActions';
import { WebinarListState } from '../configs/types';
import { SIGN_OUT } from '../../../actions/authActions';

const ID = `${config.name}/reducers/webinarReducer.js`;

export default function webinarReducer(
  state: WebinarListState = webinarListInitState,
  action: { type: string; payload?: any },
): WebinarListState {
  let nextState = { ...state };

  switch (action.type) {
    case SIGN_OUT:
      nextState = { ...webinarListInitState };
      return nextState;

    // ----- READ WEBBINAR LIST -----
    case FETCH_WEBINAR_LIST_REQUEST:
      nextState = { ...webinarListInitState };
      return nextState;
    case FETCH_WEBINAR_LIST_SUCCESS:
      // $FlowFixMe
      nextState.data = action.payload;
      return nextState;
    case FETCH_WEBINAR_LIST_FAILURE:
      nextState.error = action.payload;
      return nextState;

    // ----- WEBINAR RED DOT -----
    case ENABLE_WEBINAR_RED_DOT:
      nextState.redDot = true;
      return nextState;
    case DISABLE_WEBINAR_RED_DOT:
      nextState.redDot = false;
      return nextState;

    default:
      return nextState;
  }
}
